
import { signUpService } from '@/services/auth'
import { Form, Field, FormActions } from 'vee-validate'
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  components: {
    Form,
    Field
  },
  inject: ['setLayoutAlertText'],
  methods: {
    async handleSignUp (values: unknown, actions: FormActions<Record<string, unknown>>) {
      try {
        const res = await signUpService(this.user)
        if (!res.error) {
          this.setLayoutAlertText(res.message)
          this.$router.push({
            name: 'login',
            params: {
              email: this.user.email
            }
          })
        }
      } catch (error) {
        this.$setErrors(error, actions)
      }
    }
  }
})
